var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"theme-screen-mode"},[_c('input',{attrs:{"type":"checkbox","name":"screen"},domProps:{"checked":_vm.isActive},on:{"click":_vm.check}}),_vm._v(" "),_c('span',{staticClass:"slider-for-screen-mode"}),_vm._v("Night theme mode")])
}
var staticRenderFns = []

export { render, staticRenderFns }